type SampleProps = {
  onLoadSampleModel: (formattedSampleNumber: string) => void;
};

export const Sample = ({ onLoadSampleModel }: SampleProps) => {
  const modelItem = (sampleNumber: number) => {
    const formattedSampleNumber = sampleNumber.toString().padStart(2, '0');

    return (
      <div
        className="border hover:cursor-pointer hover:border-igus-primary-600 max-w-[150px]"
        onClick={() => onLoadSampleModel(formattedSampleNumber)}
      >
        <img
          data-testid={`sample${formattedSampleNumber}`}
          className="w-full h-full"
          draggable="false"
          src={`/_hub/images/ffh/sample${formattedSampleNumber}.png`}
          alt={`sample${formattedSampleNumber}`}
        />
      </div>
    );
  };

  return (
    <div className="grid grid-cols-2 ms:grid-cols-3 md:grid-cols-5 gap-6 h-full xl:pt-0">
      {[...Array(10).keys()].map((_, index) => modelItem(index + 1))}
    </div>
  );
};
